import React from "react";
import { Route, Redirect } from "react-router";

export function RestrictedRoute({  children,  userPermissions,  accessAllowed,  routePermissions,  resources,  render,  ...rest}) {
  const isUserAccessAllowed = accessAllowed !== false;

  if (!isUserAccessAllowed) {
    return (
      <Route {...rest}>
        <Redirect to={{ pathname: "/", state: { showPathNotAllowed: true } }} />
      </Route>
    );
  }

  let hasRoutePermission = true;
  if (routePermissions && routePermissions.length > 0) {
    hasRoutePermission = routePermissions.some((routePermission) =>
      userPermissions?.find((permission) => permission.id === routePermission)
    );
  }

  if (hasRoutePermission) {
    if (render) {
      return <Route {...rest} render={render} />;
    } else {
      return <Route {...rest}>{children}</Route>;
    }
  } else {
    return (
      <Route {...rest}>
        <Redirect to={{ pathname: "/", state: { showPathNotAllowed: true } }} />
      </Route>
    );
  }
}
